import React, { useState } from "react";
import { Button, Menu, MenuItem, Fade, makeStyles, Theme } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";

export interface DropdownMenuItem {
    label: string;
    onClick: () => void;
    tooltip?: string;
}

export interface DropdownMenuProps {
    buttonLabel: string;
    items: DropdownMenuItem[];
    chevronClass?: string;
    chevronOpenClass?: string;
}

export const useStyles = makeStyles((theme: Theme) => ({
    menuButtons: {
        padding: 0,
        paddingRight: "0.5rem",
        minWidth: 0,
        backgroundColor: "transparent",
        '&:hover': {
            backgroundColor: "transparent",
            color: "#007CAA"
        }
    }
}));

const DropdownMenu: React.FC<DropdownMenuProps> = ({
    buttonLabel,
    items,
    chevronClass = "",
    chevronOpenClass = "",
}) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const isOpen = Boolean(anchorEl);
    const classes = useStyles();

    const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <Button className={classes.menuButtons} color="default" onClick={handleOpen}>
                <span style={{ display: "flex", alignItems: "center" }}>
                    {buttonLabel}
                    <span className={`${chevronClass} ${isOpen ? chevronOpenClass : ""}`}>
                        <svg width="24" height="24" viewBox="0 0 24 24" style={{ display: "block" }}>
                            <polyline points="6 9 12 15 18 9" fill="none" stroke="#AD1457" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </span>
                </span>
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={isOpen}
                onClose={handleClose}
                TransitionComponent={Fade}
                elevation={0}
                getContentAnchorEl={null}
                disableScrollLock
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                {items.map((item, idx) => (
                    <Tooltip key={idx} title={item.tooltip ?? ""} placement="right">
                        <MenuItem
                            key={idx}
                            onClick={() => {
                                item.onClick();
                                handleClose();
                            }}
                        >
                            {item.label}
                        </MenuItem>
                    </Tooltip>
                ))}
            </Menu>
        </>
    );
};

export default DropdownMenu;